import { render, staticRenderFns } from "./2022.vue?vue&type=template&id=59783220&"
import script from "./2022.vue?vue&type=script&lang=js&"
export * from "./2022.vue?vue&type=script&lang=js&"
import style0 from "./2022.vue?vue&type=style&index=0&id=59783220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports